export interface IHttpResponse<T> extends Response {
  parsedBody?: T;
}

export const loadJsonFile = async <T>(
  request: RequestInfo,
  init?: RequestInit
): Promise<IHttpResponse<T>> =>
  new Promise((resolve, reject) => {
    let response: IHttpResponse<T>;
    fetch(request, init)
      .then((res) => {
        response = res;
        return res.json();
      })
      .then((body) => {
        if (response.ok) {
          response.parsedBody = body;
          resolve(response);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
          reject(response);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        reject(error);
      });
  });
